import type {
  AllowedStatesData,
  AllowedStatesTableColumns
} from '@library/types/allowedStates';
import type { TableColumn } from '@library/types/utils';

export const ALLOWED_STATES_TABLE_HEADER: Array<
  TableColumn<AllowedStatesTableColumns>
> = [
  {
    column: 'checkbox',
    essential: true,
    label: '',
    sortEnabled: false,
    width: 'w-[3%] px-3'
  },
  {
    column: 'id',
    essential: true,
    label: 'ID',
    sortEnabled: true,
    width: 'w-[8%] px-3'
  },
  {
    column: 'name',
    essential: true,
    label: 'Name',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  },
  {
    column: 'state_code',
    essential: true,
    label: 'State Code',
    sortEnabled: true,
    width: 'w-[10%] px-3'
  },
  {
    column: 'thirty_one_day_limit_cents',
    essential: true,
    label: '31-Day Limit (¢)',
    sortEnabled: true,
    width: 'w-[12%] px-3'
  },
  {
    column: 'f2p_only',
    essential: true,
    label: 'F2P Only',
    sortEnabled: true,
    width: 'w-[10%] px-3'
  },
  {
    column: 'allow_payments',
    essential: true,
    label: 'Payments',
    sortEnabled: true,
    width: 'w-[10%] px-3'
  },
  {
    column: 'allow_withdrawals',
    essential: true,
    label: 'Withdrawals',
    sortEnabled: true,
    width: 'w-[10%] px-3'
  },
  {
    column: 'allow_entries',
    essential: true,
    label: 'Entries',
    sortEnabled: true,
    width: 'w-[10%] px-3'
  },
  {
    column: 'created_at',
    essential: true,
    label: 'Created At',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  },
  {
    column: 'updated_at',
    essential: true,
    label: 'Updated At',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  }
];

export const DEFAULT_ALLOWED_STATES_DATA: AllowedStatesData = {
  id: '',
  name: '',
  state_code: '',
  created_at: '',
  updated_at: '',
  thirty_one_day_limit_cents: 0,
  rules: {
    allow_stats: [],
    allow_teams: [],
    allow_leagues: [],
    exclude_stats: [],
    exclude_teams: [],
    exclude_leagues: [],
    combo_play_required: false,
    default_minimum_age: 0,
    disallow_tailed_entries: false,
    disallow_in_game_lineups: false
  },
  f2p_only: false,
  allow_payments: false,
  allow_withdrawals: false,
  allow_entries: false,
  allow_mastercard: false,
  bypass_playthrough: false,
  default_game_mode: '',
  allow_venmo: false,
  allow_paypal: false,
  allow_applepay: false,
  allow_bank: false,
  allow_card: false,
  allow_visa: false,
  allow_discover: false,
  minimum_withdrawal_cents: 0,
  allowed_state_game_modes: [],
  game_modes: []
};
